import React from "react";
import { Navigate } from "react-router-dom";

const Home = React.lazy(() => import("components/home/home"));
const BlogList = React.lazy(() => import("components/blog/blog-list"));
const BlogPost = React.lazy(() => import("components/blog/blog-post"));
const About = React.lazy(() => import("components/about/about"));
const Contact = React.lazy(() => import("components/common/contact/contact"));
const NotFound = React.lazy(() => import("components/not-found/not-found"));
const ServicesHub = React.lazy(() => import("components/services/services-hub"));
const CaseStudiesPage = React.lazy(() =>
    import("components/case-studies/case-studies-page")
);
const PricingPage = React.lazy(() => import("components/pricing/pricing-page"));
const IndustriesPage = React.lazy(() =>
    import("components/industries/industries-page")
);
const MobileApps = React.lazy(() =>
    import("components/services-offered/mobile-apps/mobile-apps")
);
const WebDevelopment = React.lazy(() =>
    import("components/services-offered/web-development/web-development")
);
const CloudOperations = React.lazy(() =>
    import("components/services-offered/cloud-operations/cloud-operations")
);
const DataAnalytics = React.lazy(() =>
    import("components/services-offered/data-analytics/data-analytics")
);
const AiMlIntegration = React.lazy(() =>
    import("components/services-offered/ai-ml-integration/ai-ml-integration")
);
const PrivacyPolicy = React.lazy(() =>
    import("components/policies/privacy/privacy")
);

const routes = [
    { path: "/", element: <Home /> },
    { path: "/services", element: <ServicesHub /> },
    { path: "/services/web-development", element: <WebDevelopment /> },
    { path: "/services/mobile-development", element: <MobileApps /> },
    { path: "/services/cloud-solutions", element: <CloudOperations /> },
    { path: "/services/data-analytics", element: <DataAnalytics /> },
    { path: "/services/ai-integration", element: <AiMlIntegration /> },
    { path: "/case-studies", element: <CaseStudiesPage /> },
    { path: "/pricing", element: <PricingPage /> },
    { path: "/industries", element: <IndustriesPage /> },
    { path: "/blog", element: <BlogList /> },
    { path: "/blog/:slug", element: <BlogPost /> },
    { path: "/about", element: <About /> },
    { path: "/contact", element: <Contact /> },
    { path: "/privacy-policy", element: <PrivacyPolicy /> },

    { path: "/web-development", element: <Navigate to="/services/web-development" replace /> },
    { path: "/mobile-apps", element: <Navigate to="/services/mobile-development" replace /> },
    { path: "/cloud", element: <Navigate to="/services/cloud-solutions" replace /> },
    {
        path: "/data-analytics",
        element: <Navigate to="/services/data-analytics" replace />
    },

    { path: "*", element: <NotFound /> }
];

export default routes;
